export function formatCustomDate(value: Date | string | null): string {
  if (!value) return '';
  const date = new Date(value);
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('es-ES', { month: 'long' });
  const year = date.getFullYear();
  const formattedMonth = month.charAt(0).toUpperCase() + month.slice(1);
  return `${day} de ${formattedMonth}, ${year}`;
}
